// PWG Access V1 helpers. Never trust localStorage for authorization.
export const normalizeRole = (userDoc) =>
  String(userDoc?.role || "observer").trim().toLowerCase();

export const canEnterPWG = (userDoc) =>
  String(userDoc?.status || "pending").toLowerCase() === "active" &&
  userDoc?.features?.pwg === true;

export const isPWGAdmin = (userDoc) => normalizeRole(userDoc) === "admin";

export const isPWGPremium = (userDoc, isSubscribed = false) =>
  isSubscribed || ["premium", "pro", "guru", "admin"].includes(normalizeRole(userDoc));

// Backward-compatible role check for legacy components.
export const hasAccess = (allowedRoles = [], userDoc = null) =>
  allowedRoles.map((role) => String(role).toLowerCase()).includes(normalizeRole(userDoc));
